import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { BulkOrder } from '@app/core/models/bulk-upload.model';
import { Store } from '@ngrx/store';
import { AppState, BulkOrdersActionTypes, getBulkOrderByOrderId, getBulkOrders } from '@app/core/ngrx';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'ecp-bulk-orders',
  templateUrl: './bulk-orders.component.html',
  styleUrls: ['./bulk-orders.component.scss'],
})
export class BulkOrdersComponent implements OnInit {
  isView: boolean = false;
  bulkOrderData: any = {};
  bulkOrderItems: any;
  orderViewData: any;
  bulkOrders$: Observable<BulkOrder>;
  bulkOrderDetails$: Observable<any>;
  constructor(private store: Store<AppState>) {
    this.store.dispatch({ type: BulkOrdersActionTypes.LOAD_BULK_ORDERS });
    this.bulkOrders$ = this.store.select(getBulkOrders);
    this.bulkOrders$.subscribe((arr:any) => {
      if (arr) {
        let arrayForSort = [...arr];
        this.bulkOrderData = arrayForSort.sort((a, b) => new Date(b?.uploadedOn).getTime() - new Date(a?.uploadedOn).getTime());
      }
    });
  }

  ngOnInit(): void {}
}
